var _defs, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100,
    preserveAspectRatio: "xMidYMid meet",
    style: {
      width: "100%",
      height: "100%",
      transform: "translate3d(0px, 0px, 0px)",
      contentVisibility: "visible"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "__lottie_element_453"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    x: 0,
    y: 0
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__lottie_element_453)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "block"
    },
    transform: "matrix(0.9218549132347107,0,0,0.9218549132347107,3.9072532653808594,13.90725326538086)",
    opacity: 0.28608892794418056
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(251,207,209)",
    fillOpacity: 1,
    d: " M50,57 C63.245601654052734,57 74,62.377201080322266 74,69 C74,75.622802734375 63.245601654052734,81 50,81 C36.754398345947266,81 26,75.622802734375 26,69 C26,62.377201080322266 36.754398345947266,57 50,57z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 1,
    stroke: "rgb(0,0,0)",
    strokeOpacity: 0,
    strokeWidth: 0,
    d: " M50,57 C63.245601654052734,57 74,62.377201080322266 74,69 C74,75.622802734375 63.245601654052734,81 50,81 C36.754398345947266,81 26,75.622802734375 26,69 C26,62.377201080322266 36.754398345947266,57 50,57z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "none"
    },
    transform: "matrix(0.9999157190322876,0,0,0.9999157190322876,0.004215240478515625,6.004215240478516)",
    opacity: 0.0001458418383360538
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(251,207,209)",
    fillOpacity: 1,
    d: " M50,57 C63.245601654052734,57 74,62.377201080322266 74,69 C74,75.622802734375 63.245601654052734,81 50,81 C36.754398345947266,81 26,75.622802734375 26,69 C26,62.377201080322266 36.754398345947266,57 50,57z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 1,
    stroke: "rgb(0,0,0)",
    strokeOpacity: 0,
    strokeWidth: 0,
    d: " M50,57 C63.245601654052734,57 74,62.377201080322266 74,69 C74,75.622802734375 63.245601654052734,81 50,81 C36.754398345947266,81 26,75.622802734375 26,69 C26,62.377201080322266 36.754398345947266,57 50,57z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,-7)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(199,33,41)",
    fillOpacity: 1,
    d: " M50.10940170288086,25.22610092163086 C55.014801025390625,25.22610092163086 58.992698669433594,29.20400047302246 58.992698669433594,34.10929870605469 C58.992698669433594,39.014801025390625 55.014801025390625,42.992698669433594 50.10940170288086,42.992698669433594 C45.20399856567383,42.992698669433594 41.22610092163086,39.014801025390625 41.22610092163086,34.10940170288086 C41.22610092163086,29.20400047302246 45.20399856567383,25.22610092163086 50.10940170288086,25.22610092163086z M50.10940170288086,13 C38.45100021362305,13 29,22.451000213623047 29,34.10940170288086 C29,38.008201599121094 29.763099670410156,42.035099029541016 31.953100204467773,44.9375 C31.953100204467773,44.9375 49,69 50.10940170288086,69 C51.21879959106445,69 68.2656021118164,44.9375 68.2656021118164,44.9375 C70.25479888916016,42.301300048828125 71.21869659423828,37.640899658203125 71.21869659423828,34.10940170288086 C71.21880340576172,22.451000213623047 61.7677001953125,13 50.10940170288086,13z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 1,
    stroke: "rgb(0,0,0)",
    strokeOpacity: 0,
    strokeWidth: 0,
    d: " M50.10940170288086,25.22610092163086 C55.014801025390625,25.22610092163086 58.992698669433594,29.20400047302246 58.992698669433594,34.10929870605469 C58.992698669433594,39.014801025390625 55.014801025390625,42.992698669433594 50.10940170288086,42.992698669433594 C45.20399856567383,42.992698669433594 41.22610092163086,39.014801025390625 41.22610092163086,34.10940170288086 C41.22610092163086,29.20400047302246 45.20399856567383,25.22610092163086 50.10940170288086,25.22610092163086z M50.10940170288086,13 C38.45100021362305,13 29,22.451000213623047 29,34.10940170288086 C29,38.008201599121094 29.763099670410156,42.035099029541016 31.953100204467773,44.9375 C31.953100204467773,44.9375 49,69 50.10940170288086,69 C51.21879959106445,69 68.2656021118164,44.9375 68.2656021118164,44.9375 C70.25479888916016,42.301300048828125 71.21869659423828,37.640899658203125 71.21869659423828,34.10940170288086 C71.21880340576172,22.451000213623047 61.7677001953125,13 50.10940170288086,13z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.6d8261e9eab83978214621e08695d32f.svg";
export { ForwardRef as ReactComponent };